import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
  faYoutube, 
  faLinkedin, 
  faInstagram 
} from "@fortawesome/free-brands-svg-icons";
import { 
  faBars, 
  faTimes 
} from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../features/auth/authSlice";


// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { 
//   faBars, 
//   faTimes,
//   faYoutube,
//   faLinkedin,
//   faInstagram
// } from "@fortawesome/free-solid-svg-icons";
// import { useDispatch, useSelector } from "react-redux";
// import { logout } from "../features/auth/authSlice";
import "./Header.css"; // Make sure this import path is correct

const Header = () => {
  const token = useSelector((state) => state.auth.token);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
    setMenuOpen(false);
  };

  // Close menu when a link is clicked
  const closeMenu = () => setMenuOpen(false);

  return (
    <header className="header">
      <div className="container">
        <div className="navbar">
          <Link to="/" className="logo" onClick={closeMenu}>
            Code<span>XLNC</span>
          </Link>

          {/* Mobile menu button */}
          <button 
            className="menu-toggle"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-expanded={menuOpen}
            aria-label="Menu"
          >
           <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} />

          </button>
          {/* <FontAwesomeIcon icon={menuOpen ? faTimes : faBars} /> */}


          {/* Navigation links */}
          <nav className={`nav-links ${menuOpen ? "show" : ""}`}>
            <Link to="/" onClick={closeMenu}>Home</Link>
            <Link to="/courses" onClick={closeMenu}>Courses</Link>
            {/* <Link to="/recorded-classes" onClick={closeMenu}>Recorded</Link> */}
            <Link to="/enroll" onClick={closeMenu}>Enroll</Link>
            <Link to="/contact" onClick={closeMenu}>Contact</Link>
            <Link to="/About" onClick={closeMenu}>About</Link>

            {/* {token ? (
              <>
                <Link to="/dashboard" onClick={closeMenu}>Dashboard</Link>
                <button className="logout-btn" onClick={handleLogout}>Logout</button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={closeMenu}>Login</Link>
                <Link to="/signup" onClick={closeMenu}>Signup</Link>
              </>
            )} */}

            <div className="social-icons">
              <a href="https://www.youtube.com/@SalesforceWithKC" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faYoutube} />
              </a>
              <a href="https://www.linkedin.com/in/malyala-kalyan-chakravarthy-goud-844745219/" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faLinkedin} />
              </a>
              <a href="#https://www.instagram.com/salesforcewithkc/" target="_blank" rel="noreferrer">
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;